import { Col, Row } from 'react-bootstrap'
import { map } from 'lodash'
import ProductContentSection from './product-content-section'
import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'

const ProductVideos = ({ videos }) => {
  const { flagValue: variationValue } = useFeatureFlag(
    '24c_ex_shop_pdp_redesign_rollout',
    'control'
  )

  const showNewPDP = variationValue !== 'control'

  return (
    <ProductContentSection
      title={showNewPDP ? 'Related videos' : 'Related Videos'}
    >
      {map(videos, (video) => (
        <Row key={video.url}>
          <Col sm={8} smOffset={2}>
            <div className="mbxl embed-responsive embed-responsive-16by9">
              <iframe loading="lazy" src={video.url} allowFullScreen />
            </div>
          </Col>
        </Row>
      ))}
    </ProductContentSection>
  )
}

export default ProductVideos
